<!-- Top bar -->
<mat-toolbar class="topBar" color="#005d87">

  <!-- Back to Home -->
  <button mat-icon-button
          class="example-icon"
          type="button"
          aria-label="Example icon-button with menu icon"
          matTooltip="Back to Home"
          matTooltipPosition="below"
          (click)="router.navigate(['menu'])">
    <mat-icon>
      arrow_back
    </mat-icon>
  </button>

  <!-- Page title -->
  <span style="color: white;">
    My Profile
  </span>

</mat-toolbar>


<div class="container">

  <form [formGroup]="profileForm">
    <div class="row justify-content-center" style="padding-top: 25px;">

      <mat-form-field appearance="fill">
        <mat-label>Vessel Operator First Name</mat-label>
        <input matInput formControlName="firstName" required>
        <mat-error *ngIf="profileForm.get('firstName')?.errors?.required">Required</mat-error>
        <mat-error *ngIf="profileForm.get('firstName')?.errors?.pattern">Invalid character</mat-error>
      </mat-form-field>
  
    </div>
  
    <div class="row justify-content-center">
  
      <mat-form-field appearance="fill">
        <mat-label>Vessel Operator Last Name</mat-label>
        <input matInput formControlName="lastName" required>
        <mat-error *ngIf="profileForm.get('lastName')?.errors?.required">Required</mat-error>
        <mat-error *ngIf="profileForm.get('lastName')?.errors?.pattern">Invalid character</mat-error>
      </mat-form-field>
  
    </div>
  
    <div class="row justify-content-center">
  
      <mat-form-field appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" required>
        <mat-icon matSuffix>mail</mat-icon>
        <mat-error *ngIf="profileForm.get('email')?.errors?.required">Required</mat-error>
        <mat-error *ngIf="profileForm.get('email')?.errors?.email">Invalid email</mat-error>
      </mat-form-field>
  
    </div>
  
    <div class="row justify-content-center">
  
      <mat-form-field #telField appearance="fill">
        <mat-label>Phone Number</mat-label>
        <app-tel-input #telInput formControlName="phoneNum"></app-tel-input>
        <mat-icon matSuffix>phone</mat-icon>
        <mat-error *ngIf="!profileForm.get('phoneNum')?.value">Required</mat-error>
      </mat-form-field>
  
    </div>
  
    <div class="row justify-content-center">
  
      <mat-form-field appearance="fill">
        <mat-label>State Fisher License Number</mat-label>
        <input matInput formControlName="licenseNum">
        <mat-error *ngIf="profileForm.get('licenseNum')?.errors?.maxlength || profileForm.get('licenseNum')?.errors?.minlength">5 - 8 characters required</mat-error>
        <mat-error *ngIf="profileForm.get('licenseNum')?.errors?.pattern">Invalid character: Numbers and letters only</mat-error>
      </mat-form-field>
  
    </div>
  
  </form>
  
</div>
